module.exports = __webpack_public_path__ + "c6a95bcf92f959198d75ab46b5b06289.MP3";